<template>
 <div class="col-12 col-lg-6">
    <!-- ADD : START -->
   <component-form-add
   @handleAddTaskApp = "handleAddTaskApp"
   :isFormShow = "isFormShow"
	
   ></component-form-add>
    <!-- ADD : END -->

    <form
		
    action="" method="POST" class="form-inline justify-content-between" v-if = "isFormShow" >
      <div class="form-group">
        <label class="sr-only" for="">label</label>
        <input v-model="taskName" type="text" class="form-control" placeholder="Task Name" />

      </div>
      <div class="form-group">
        <label class="sr-only" for="">label</label>
        <select v-model = "levelTag" name="ds" class="form-control" required="required">
          <option value="0">Low</option>
          <option value="1">Medium</option>
          <option value="2">High</option>
        </select>
      </div>

      <button
      	v-if = "taskEdit"
		@click.prevent = "handleUpdate"
      type="button" class="btn btn-primary">Update</button>

      <button
      	v-else
		@click.prevent = "handleSubmit"
      type="button" class="btn btn-primary">Submit</button>
      <button
		@click = "handleCancel"
      	type="button" class="btn btn-secondary">Cancel</button>

    </form>
  </div>
</template>
<script type="text/javascript">
	const uuidv4 = require('uuid/v4');	
	import ComponentFormAdd from './ComponentFormAdd.vue';
	export default {
		name: "component-form",
		props: {
			isFormShow: {
				type: Boolean,
				default: false				
			},

			taskEdit:{
				type: Object,
				default: null
			}
		},

		data: function(){
			return {
				taskName: "",
				levelTag: 0
			}
		},

		watch:{

			taskEdit: function(newdata, olddata){

				if(newdata !== null){
					this.taskName = newdata.taskName;
					this.levelTag = newdata.level;
				}
							
			}

		},

		components: {
			ComponentFormAdd
		},

		methods: {

			
			handleUpdate: function(){

				let taskUpdateObject= {

					id: this.taskEdit.id,

					taskName: this.taskName,

					level: parseInt(this.levelTag)
				}

				this.$emit("handleUpdateApp", taskUpdateObject);

				this.handleCancel();
				
			},


			handleAddTaskApp: function(){
				
				this.$emit("handleAddTaskAppVue");
				
			},

			handleCancel: function(){

				this.$emit("handleAddTaskAppVue");
				this.taskName = "",
				this.levelTag = null;
			},

			handleSubmit: function(){

				if(this.taskName === ""){

					alert("The taskName is empty!");

					return;
				}

				let dataSubmit = {
					id: uuidv4(),
					taskName: this.taskName,
					level: parseInt(this.levelTag)
				};

				console.log(dataSubmit);

				this.$emit("handleSubmitApp", dataSubmit);
			}
		}
	}
</script>
<style type="text/css"></style>